import SalesManagementGZMB from './SalesManagementGZMB.vue'

export default SalesManagementGZMB


// WEBPACK FOOTER //
// ./src/pages/salesManagement/gzmb/index.js